export default {
  SnippetStarted: "Snippet Started",
  SnippetStopped: "Snippet Stopped",
  StartSnippet: "Start Snippet",
  StartFrom30sAgo: "Start from 30s ago",
  StartFrom10sAgo: "Start from 10s ago",
  StartNow: "Start now",
  StopSnippet: "Stop Snippet",
  SnippetDescription: "Snippet Description",
  SnippetSuccess: "Snippet saved successfully",
  SnippetFailed: "Snippet operation failed",
  SnippetActive: "Snippet Active",
  SnippetCannedResponses: "Snippet Descriptions",
  ScreenshotsAndSnippets: "Screenshots & Snippets",
  "Events.SnippetStarted": "Snippet Started",
  "Events.SnippetStopped": "Snippet Stopped",
};
